import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, InputLabel, Select, MenuItem, Box, Button } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { SEQ_CATEGORIES, TRIGGER_UNITS, TRIGGER_DIRS, SEQ_VARS_HINT } from "./appointments.config.constants";

// D8.7.4a — Diálogo crear/editar Secuencia (presentacional).
export default function SeqDialog({ seqDialogOpen, setSeqDialogOpen, seqDialogMode, seqDialogData, setSeqDialogData, handleSaveSeqDialog, seqDialogSaving }) {
  return (
          <Dialog open={seqDialogOpen} onClose={() => setSeqDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>
              {seqDialogMode === "create"
                ? i18n.t("appointmentsModule.config.seqDialogCreateTitle")
                : i18n.t("appointmentsModule.config.seqDialogEditTitle")}
            </DialogTitle>
            <DialogContent>
              <TextField
                label="Nombre"
                fullWidth
                margin="dense"
                variant="outlined"
                value={seqDialogData.name}
                onChange={(e) => setSeqDialogData(p => ({ ...p, name: e.target.value }))}
              />
              <TextField
                label="Descripción"
                fullWidth
                margin="dense"
                variant="outlined"
                value={seqDialogData.description}
                onChange={(e) => setSeqDialogData(p => ({ ...p, description: e.target.value }))}
              />
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel>Categoría</InputLabel>
                <Select
                  value={seqDialogData.category}
                  onChange={(e) => setSeqDialogData(p => ({ ...p, category: e.target.value }))}
                  label="Categoría"
                >
                  {SEQ_CATEGORIES.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
                </Select>
              </FormControl>
              <Box style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "flex-end" }}>
                <TextField
                  label="Tiempo"
                  type="number"
                  margin="dense"
                  variant="outlined"
                  style={{ width: 90 }}
                  value={seqDialogData.triggerValue}
                  onChange={(e) => setSeqDialogData(p => ({ ...p, triggerValue: Number(e.target.value) }))}
                  inputProps={{ min: 0 }}
                />
                <FormControl margin="dense" variant="outlined" style={{ minWidth: 120 }}>
                  <InputLabel>Unidad</InputLabel>
                  <Select
                    value={seqDialogData.triggerUnit}
                    onChange={(e) => setSeqDialogData(p => ({ ...p, triggerUnit: e.target.value }))}
                    label="Unidad"
                  >
                    {TRIGGER_UNITS.map(u => <MenuItem key={u.value} value={u.value}>{u.label}</MenuItem>)}
                  </Select>
                </FormControl>
                <FormControl margin="dense" variant="outlined" style={{ minWidth: 170 }}>
                  <InputLabel>Dirección</InputLabel>
                  <Select
                    value={seqDialogData.triggerDirection}
                    onChange={(e) => setSeqDialogData(p => ({ ...p, triggerDirection: e.target.value }))}
                    label="Dirección"
                  >
                    {TRIGGER_DIRS.map(d => <MenuItem key={d.value} value={d.value}>{d.label}</MenuItem>)}
                  </Select>
                </FormControl>
              </Box>
    
              {/* Plantilla del mensaje */}
              <Box style={{ marginTop: 16 }}>
                <TextField
                  label="Plantilla del mensaje"
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  value={seqDialogData.messageTemplate}
                  onChange={(e) => setSeqDialogData(p => ({ ...p, messageTemplate: e.target.value }))}
                  placeholder="Escribe el mensaje que se enviará al contacto…"
                  helperText={`Variables disponibles: ${SEQ_VARS_HINT}`}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setSeqDialogOpen(false)}>
                Cancelar
              </Button>
              <Button
                onClick={handleSaveSeqDialog}
                disabled={seqDialogSaving || !seqDialogData.name.trim()}
                color="primary"
                variant="contained"
              >
                {seqDialogSaving ? "Guardando…" : "Guardar"}
              </Button>
            </DialogActions>
          </Dialog>
  );
}
